/*
 * Partage de panier maison (remplace l'app Bevy Share Cart).
 * Construit un permalien natif Shopify et le copie dans le presse-papiers.
 * `storefront=true` est indispensable : sans lui, Shopify redirige le
 * destinataire directement vers le checkout au lieu de la page panier.
 * Ouvrir le lien remplace le panier du destinataire par celui partagé.
 */
customElements.define('share-cart-button', class extends HTMLElement {
    connectedCallback() {
        this.btn = this.querySelector('[data-share-cart-trigger]');
        this.btn?.addEventListener('click', () => this._share());
    }

    async _share() {
        const d = this.btn.dataset;
        try {
            const cart = await fetch('/cart.js').then(r => r.json());
            if (!cart.items.length) {
                this._toast('warning', d.empty);
                return;
            }
            // window.shopUrl (= shop.url) garantit un lien vers le domaine
            // public même depuis un aperçu ou "shopify theme dev" en local.
            // Les UTM permettent l'attribution des commandes issues d'un lien
            // partagé : visibles dans le résumé de conversion Shopify de chaque
            // commande et dans GA4 (source/médium = share-cart/referral).
            const base = (window.shopUrl || location.origin).replace(/\/$/, '');
            const link = `${base}/cart/`
                + cart.items.map(i => `${i.variant_id}:${i.quantity}`).join(',')
                + '?storefront=true'
                + '&utm_source=share-cart&utm_medium=referral&utm_campaign=cart-link';
            await this._copy(link);
            this._track(cart);
            this._flash(d.copied);
            this._toast('success', d.copied, d.toast);
        } catch (e) {
            this._toast('error', d.error);
        }
    }

    async _copy(text) {
        if (navigator.clipboard && window.isSecureContext) {
            return navigator.clipboard.writeText(text);
        }
        const ta = document.createElement('textarea');
        ta.value = text;
        ta.style.position = 'fixed';
        ta.style.opacity = '0';
        document.body.appendChild(ta);
        ta.select();
        document.execCommand('copy');
        ta.remove();
    }

    _track(cart) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: 'share_cart_link_copied',
            cart_value: cart.total_price / 100,
            cart_currency: cart.currency,
            cart_items: cart.item_count
        });
    }

    _toast(type, title, message) {
        document.dispatchEvent(new CustomEvent('toast-notification:open', {
            bubbles: false,
            cancelable: true,
            composed: true,
            detail: { data: { type, title, message } }
        }));
    }

    _flash(text) {
        if (!text) return;
        const label = this.btn.querySelector('[data-share-cart-label]');
        label.textContent = text;
        clearTimeout(this._t);
        this._t = setTimeout(() => {
            label.textContent = this.btn.dataset.label;
        }, 2500);
    }
});
